import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Redirect } from 'react-router-dom';

const PageContainer = styled.div`
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  text-align: center;
  padding: 40px 16px;
  background: #FAF9FB;
  box-sizing: border-box;
`;

const Card = styled.div`
  max-width: 420px;
  margin: 40px auto;
  background: #ffffff;
  border-radius: 16px;
  padding: 32px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
`;

const Title = styled.h2`
  color: #32104F;
  margin-top: 0;
  margin-bottom: 12px;
  font-size: 24px;
`;

const Description = styled.p`
  color: #666;
  margin-bottom: 28px;
  font-size: 15px;
  line-height: 1.5;
`;

const ActionButton = styled.a`
  display: block;
  background: #442165;
  color: #fff;
  text-decoration: none;
  padding: 14px 20px;
  border-radius: 10px;
  font-weight: bold;
  margin-bottom: 12px;
  font-size: 15px;
  transition: opacity 0.2s;

  &:hover {
    color: #fff;
    opacity: 0.9;
  }
`;

const StoreButton = styled(ActionButton)`
  background: #ECE6F3;
  color: #442165;

  &:hover {
    color: #442165;
    background: #e3d9ec;
  }
`;

const CommunityInvite = () => {
  const path = window.location.pathname.replace(/^\/+/, '');
  const pathParts = path.split('/').filter(Boolean);

  // Check if an ID or code is provided:
  // /i/:code -> pathParts: ['i', 'code']
  // /community/join/:id -> pathParts: ['community', 'join', 'id']
  const hasIdentifier =
    (pathParts[0] === 'i' && pathParts.length > 1) ||
    (pathParts[0] === 'community' && pathParts[1] === 'join' && pathParts.length > 2);

  const schemeUrl = `supportroom://${path}`;

  useEffect(() => {
    document.title = 'Join SupportRoom Community';

    // Auto-attempt redirect on mobile device browser
    if (hasIdentifier && /Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      window.location.href = schemeUrl;
    }
  }, [hasIdentifier, schemeUrl]);

  if (!hasIdentifier) {
    return <Redirect to="/" />;
  }

  return (
    <PageContainer>
      <Card>
        <Title>Join Community Channel</Title>
        <Description>You have been invited to join a SupportRoom community channel.</Description>
        <ActionButton id="openAppBtn" href={schemeUrl}>
          Open in SupportRoom App
        </ActionButton>
        <StoreButton
          href="https://apps.apple.com/app/supportroom/id6445840595"
          target="_blank"
          rel="noopener noreferrer"
        >
          Download on App Store
        </StoreButton>
        <StoreButton
          href="https://play.google.com/store/apps/details?id=com.codingmachine"
          target="_blank"
          rel="noopener noreferrer"
        >
          Get it on Google Play
        </StoreButton>
      </Card>
    </PageContainer>
  );
};

export default CommunityInvite;
